const ACTION_KEY = 'REPORT_PRODUCTIVITY';

const initialState = () => ({
  loading: false,
  reportProductivity: null,
  error: null,
  required: false,
  paramsFilter: {
    dateFrom: null,
    dateTo: null,
    responsibleType: null,
    businessPartners: [],
    professions: [],
    branchs: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_PENDING`: {
      return {
        ...state,
        loading: true,
        required: true
      };
    }

    case `${ACTION_KEY}_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }

    case `${ACTION_KEY}_FULFILLED`: {
      const reportProductivity = action.payload.data;
      const paramsFilter = action.payload.paramsFilter;
      return {
        ...state,
        loading: false,
        reportProductivity,
        paramsFilter
      };
    }
    case `${ACTION_KEY}_DOWNLOAD_PDF_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${ACTION_KEY}_DOWNLOAD_PDF_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }

    case `${ACTION_KEY}_DOWNLOAD_PDF_FULFILLED`: {
      return {
        ...state,
        loading: false
      };
    }

    case `${ACTION_KEY}_CSV_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${ACTION_KEY}_CSV_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    }

    case `${ACTION_KEY}_CSV_FULFILLED`: {
      return {
        ...state,
        loading: false
      };
    }

    case `${ACTION_KEY}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
